<template>
  <v-container>
    <div v-if="!editingThresholds">
      <v-btn
        v-if="canEditThresholds"
        class="icon-btn float-right"
        color="primary"
        @click="toggleEditThreshold"
      >
        <v-icon>
          $faCog
        </v-icon>
        Edit Thresholds
      </v-btn>
      <div style="clear:both" />
      <activity-zone-list :activity-zones-list="activityZonesList" />
    </div>
    <div v-else>
      <edit-thresholds
        :activity-zones-list="activityZonesList"
        @cancel-edit="toggleEditThreshold"
      />
    </div>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ActivityZoneList from '@/components/activityZones/ActivityZoneList'
  import EditThresholds from '@/components/activityZones/EditThresholds'

  export default {
    name: 'ZoneThresholdList',
    components: {
      ActivityZoneList,
      EditThresholds,
    },
    data () {
      return {
        editingThresholds: false,
      }
    },
    async created () {
      await this.fetchList()
    },
    computed: {
      ...mapGetters({ canEditThresholds: 'Permissions/canManageSelectedOrg', activityZonesList: 'ActivityZones/zones' }),
    },
    methods: {
      fetchList () {
        const payload = { id: this.$route.params.id }
        this.$store.dispatch('ActivityZones/fetchZones', payload)
      },
      toggleEditThreshold () {
        this.editingThresholds = !this.editingThresholds
      },
    },
  }
</script>
